export const RELATED_PRODUCTS_FREQUENTLY_ORDERED_AUTOMATION =
  'related_products_frequently_ordered_automation'
export const RELATED_PRODUCTS_FREQUENTLY_ORDERED_AUTOMATION_VARIATION = 'test'
